export const environment = {
  production: false,
  apiURL: "https://cgosdevukservices.storegene.com/",
  logo: `./assets/logo/storeGene_text.png`,
  appTitle: 'StoreGene',
  
   azureBlobStorage: ''
  
};
